module.exports = function() {
  return new Worker(__webpack_public_path__ + "defe7df108364ef2e49a.worker.js");
};